import { getSelectedTableView, isSingleItemSelection } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-analytics-types';
import { lazyReportItems } from 'owa-mail-triage-action';
import { lazyOnSingleSelectionChanged } from 'owa-mail-mark-read-actions';
import { ReportType } from 'owa-reporting';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export default async function onJunkNotJunk(
    actionSource: ActionSource,
    isJunkValueToSet: boolean,
    onReportCompleted?: (reportAttempted: boolean) => void
): Promise<void> {
    const tableView = getSelectedTableView(true /*shouldGetEffectiveView*/);
    const rowKeys = getEffectiveRowKeys(tableView);

    //Mark as read when junk from menu, only when a single item is selected, since that is the
    //only case where the item is shown in the reading pane.
    if (isSingleItemSelection(tableView)) {
        const selectedRowKey = [...tableView.selectedRowKeys.keys()][0];
        lazyOnSingleSelectionChanged.importAndExecute(selectedRowKey, tableView, true);
    }

    void lazyReportItems
        .importAndExecute(
            isJunkValueToSet ? ReportType.Junk : ReportType.NotJunk,
            rowKeys,
            tableView,
            actionSource
        )
        .then(reported => onReportCompleted?.(!!reported))
        .catch(() => onReportCompleted?.(false));
}
